import {saveToStore, StorePath} from './store.service';
import MessageModel from '../models/message.model';
import Message, {ROLE} from '../models/message.model';
import {snippetService} from './snippet.service';
import {convertNameIntoFirstAndLast, logger} from './utils.service';
import {Lead} from '../models/lead.model';
import {CONVERSION_TYPE} from '../models/conversion-type.enum';

// BE does not send more than 1 message in the message API call
export const addLatestMessage = (messages: Record<'message', MessageModel>[], storeMessages: Message[], storeAction: unknown): void => {
	const latestMessageIndex = messages?.length - 1;
	const latestMessage = messages?.[latestMessageIndex]?.message;
	const message = {...latestMessage, role: ROLE.ASSISTANT} as MessageModel;
	addNewMessage(message, storeMessages, storeAction);
};

export const addNewMessage = (messagePayload: MessageModel, storeMessages: Message[], storeAction: unknown): void => {
	storeMessages.push(messagePayload);
	saveToStore(storeAction, StorePath.MESSAGES, storeMessages);
};

export const handleConversion = (response: any, storeAction: unknown): void => {
	if (response.is_conversion) {
		saveToStore(storeAction, StorePath.CONVERSION_RECORDED, true);
		logger('Conversion recorded', response.lead);

		const lead = {...response.lead};
		const {first_name, last_name} = convertNameIntoFirstAndLast(lead.name);
		const formattedLead: Lead = {
			first_name,
			last_name,
			phone: lead.phone,
			email: lead.email,
			department: lead.department,
		};
		snippetService.sendConversionMessage(formattedLead, CONVERSION_TYPE.CONVERSATIONAL);
	}
};
